import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="flex min-h-screen items-center justify-center bg-onyx px-4 text-center">
      <Seo title="Page Not Found" description="The requested mellowjmedia page could not be found." />
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.42em] text-gold">404 / Off track</p>
        <h1 className="mt-5 font-display text-6xl font-light text-white">This frame is missing.</h1>
        <Link data-testid="not-found-home-button" to="/" className="mt-8 inline-flex border border-gold/40 px-6 py-3 font-mono text-xs uppercase tracking-[0.22em] text-gold hover:bg-gold hover:text-onyx">Return home</Link>
      </div>
    </div>
  );
}
